export default __webpack_public_path__ + "static/CurriculumImage-cc2c53fa64697dd2ce84a916ab2e7301.webp";